import * as React from 'react';
const AnchorContext = /*#__PURE__*/React.createContext(undefined);
export default AnchorContext;